import { dataEyeSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEyeSolid = /*#__PURE__*/createIcon(dataEyeSolid)
export default IconEyeSolid
